import React, { useCallback, useState } from 'react';

import { ListItemIcon, MenuItem } from '@mui/material';
import qs from 'qs';
import { generatePath, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useVersionStore } from 'store/version.store';

import { useMutationDeleteCard } from 'api/mutations/deleteCard.mutation';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/UserActionCardModal/components/SideMenu/SideMenu.module.scss';
import {
    CustomizedConfirmDeleteModal,
    CustomizedDropdownMenu,
    CustomizedRoundIcon,
    CustomizedTooltip,
} from 'components/common';

interface ISideMenuProps {
    title: string;
    taskId: number;
    id: number;
    handleModalClose: () => void;
    deleteCardCallback: () => void;
}

export const SideMenu = ({ title, taskId, id, handleModalClose, deleteCardCallback }: ISideMenuProps) => {
    const [deleteCardModalShow, setDeleteCardModalShow] = useState<boolean>(false);

    const history = useHistory();
    const { path } = useRouteMatch();
    const params = useParams();
    const { search } = useLocation();
    const { handleSnackBar } = useCustomSnackBar();
    const version = useVersionStore((state) => state.version);
    const { mutate: deleteCardMutate, isLoading: deleteCardLoading } = useMutationDeleteCard();

    const handleCardDelete = useCallback(() => {
        setDeleteCardModalShow(false);
        if (id && version) {
            deleteCardMutate(
                { cardId: id, versionId: version.id },
                {
                    onSuccess: () => {
                        handleSnackBar('Card Deleted Successfully', 'success');
                        handleModalClose();
                        deleteCardCallback();
                    },
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                },
            );
        }
    }, []);

    const handleCreateUserAction = (taskId: number) => {
        const newSearch = qs.stringify({ ...qs.parse(search), taskId: taskId });
        const pathname = generatePath(path, { ...params, cardId: 'newCard' });
        setTimeout(() => {
            history.push({
                pathname,
                search: newSearch,
            });
        }, 0);
    };

    return (
        <div className={classes.sideMenuContainer}>
            <ShareInsightButton title={`activity "${title}"`} link={window.location.href.split('?')[0]} size={'3rem'} />

            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipContent={`Manage Activity`}
                        triggerElement={
                            <CustomizedRoundIcon size={'30px'}>
                                <Icon name={'three-dot-icon'} />
                            </CustomizedRoundIcon>
                        }
                    />
                }
            >
                {taskId && (
                    <MenuItem
                        onClick={() => {
                            handleCreateUserAction(taskId);
                        }}
                    >
                        <ListItemIcon>
                            <MuiIcon icon={'add'} />
                        </ListItemIcon>
                        Add Associated User Action
                    </MenuItem>
                )}

                <MenuItem
                    onClick={() => {
                        setDeleteCardModalShow(true);
                    }}
                >
                    <ListItemIcon>
                        <MuiIcon icon={'delete'} type={'outlined'} />
                    </ListItemIcon>
                    Delete
                </MenuItem>
            </CustomizedDropdownMenu>

            <CustomizedConfirmDeleteModal
                isShowModal={deleteCardModalShow}
                hideModal={() => {
                    setDeleteCardModalShow(false);
                }}
                text={'Are you sure you want to delete this Card?'}
                onConfirm={handleCardDelete}
                isLoading={deleteCardLoading}
            />
        </div>
    );
};
